module.exports = __webpack_public_path__ + "img/refresh.d464bb74.svg";